






























import {
  defineComponent,
  ref,
} from '@vue/composition-api';
import { DialogView, Toast } from '@hb/coffee';
import { ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import ContractPreviewApi from '@/api/payOff-Certificate';
import { checkEmail } from '@/shared/utils/validator';
import { SendEmailResult } from '@/api/payOff-Certificate/enum';

export default defineComponent({
  components: {
    DialogView,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    loanOrderId: {
      type: String,
      default: '',
    },
  },
  emits: ['confirm', 'cancel', 'close'],
  setup(props, context) {
    const emailTxt = ref<HTMLInputElement | null>(null);
    const isSending = ref(false);

    const onBlurFixed = () => {
      window.scrollTo(0, 0);
      document.body.scrollTop = document.body.scrollHeight;
    };

    const onValidator = (): boolean => {
      if (!checkEmail(emailTxt.value?.value || '')) {
        Toast('请填写正确的邮箱地址');
        return false;
      }
      return true;
    };

    const onClosed = () => {
      context.emit('close');
    };

    const onSubmit = async () => {
      if (isSending.value) return;
      isSending.value = true;

      try {
        const email = emailTxt.value?.value || '';

        if (onValidator()) {
          const result = await ContractPreviewApi.sendToEmail(email, props.loanOrderId);
          if (result.result === SendEmailResult.SUCCESS) {
            onClosed();
            Toast.success('提交成功！预计3-5个工作日内发送至您的邮箱');
          } else {
            Toast(result.errorMsg || '发送失败请重试');
          }
        }
        ubtSetupPageButton('finance_loan_payoffCertificate_sendEmailButton');
      } finally {
        isSending.value = false;
      }
    };

    return {
      emailTxt,
      onClosed,
      onBlurFixed,
      onSubmit,
    };
  },
});
